import { lazyComponents } from '../constant/lazy-components.const';

export function lazyArrayToObj() {
  const result = {};
  for (const w of lazyComponents) {
    result[w.path] = w.loadChildren;
  }
  return result;
}
